import { toLogin } from '@bilibili-business/site-main-login-utils'
import { isObject } from '.'

export const loginOption = {
  LAN_HOST: '.bilibili.co',
  WAN_HOST: '.bilibili.com',
  WAN_LOGIN: `//${window.location.hostname}${window.location.pathname}#/login`, // huahuo.bilibili.com/#/login',
  ERROR_Page: `//${window.location.hostname}${window.location.pathname}#/404`, // huahuo.bilibili.com/#/login',
  LAN_DASHBOARD_URL: '//dashboard-mng.bilibili.co/login.html',
  ACCOUNT_URL: '//e.bilibili.com/site/login?system_type=hua_huo', // 营销整合平台登录
  WHOLE_URL: `${window.location.protocol}//${window.location.hostname}/#/`
}

/**
 * @description 判断是否是内网
 */
export function isLan() {
  const reg = new RegExp(`${loginOption.LAN_HOST}$`, 'i')
  return reg.test(window.location.hostname)
}

/**
 * @description 判断是否是外网
 */
export function isWan() {
  const reg = new RegExp(`${loginOption.WAN_HOST}$`, 'i')
  return reg.test(window.location.hostname)
}

/**
 * @description 跳转dashboard
 */
export function redirectLanDashboard() {
  window.location.href = loginOption.LAN_DASHBOARD_URL
}
/**
 * @description 跳转营销官网
 */
// 直接取出未编译的传递即可
function getParamsFromLocal(key) {
  try {
    return window.sessionStorage.getItem(key)
  } catch (e) {
    console.log(e)
    return ''
  }
}
export function redirectAccountLogin() {
  // 重定向加参数给品牌银行, 存在本地从本地拿
  // 存在本地
  const params = getParamsFromLocal('customer')
  if (params) {
    window.location.href = loginOption.ACCOUNT_URL + '&customer=' + params
  } else {
    window.location.href = loginOption.ACCOUNT_URL
  }
}

export function redirectWanLogin() {
  window.location.href = loginOption.WAN_LOGIN
}

export function redirectSystemLogin() {
  toLogin({ systemType: 'hua_huo' }).catch(e => {
    // 如果接口等报错，会通过reject 返回， 业务方可以根据需要暴露
    console.error(e)
  })
}

export function urlHasBidGrey() {
  let name = 'bid_grey'
  let search = window.location.search.substr(1) || window.location.hash.split('?')[1]
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  if (search) {
    let r = search.match(reg)
    if (r != null) return unescape(r[2])
  } else {
    return ''
  }
}

export function redirectErrorPage() {
  window.location.href = loginOption.ERROR_Page
}

export function isRegister() {
  return window.location.hash === '#/register'
}

export function fromOtherSys() {
  const hash = window.location.hash

  return /[customer|task|order]_id|[?|&]from=|domain=\w*/.test(hash)
}

export function withoutCookieAuth() {
  const hash = window.location.hash

  return /domain=[up|mcn|ad]/.test(hash)
}

export const toMainWeb = {
  upper: 'https://member.bilibili.com/v2#/allowance/pick_up',
  mcn: 'https://member.bilibili.com/studio/mcn/m/business/quote',
  mcnLogin: 'https://member.bilibili.com/studio/mcn/entry'
}

export function setSessionStorage(id, value) {
  try {
    window.sessionStorage.setItem(id, value)
  } catch (e) {
    console.log(e)
  }
}

export function getSessionStorage(id) {
  return window.sessionStorage.getItem(id)
}

export function setCookie(str) {
  document.cookie = str
}

export function isJSON(str) {
  if (typeof str === 'string') {
    try {
      JSON.parse(str)
      return true
    } catch (e) {
      return false
    }
  }
}

export function getCookie(name) {
  if (document.cookie.length > 0) {
    let start = document.cookie.indexOf(name + '=')
    if (start !== -1) {
      start = start + name.length + 1
      let end = document.cookie.indexOf(';', start)
      if (end === -1) end = document.cookie.length
      let str = unescape(document.cookie.substring(start, end))
      if (isJSON(str)) {
        str = JSON.parse(str)
      }
      return str
    }
  }
  return ''
}

export function clearCookie(name) {
  var exdate = new Date()
  exdate.setDate(exdate.getDate() + -1)
  document.cookie = name + '=' + escape('') + ';expires=' + exdate.toGMTString() + ';path=/'
}

export class OperateScroll {
  constructor(el = 'body') {
    this.dom = document.querySelector(el)
  }

  hidden() {
    this.dom.style.overflow = 'hidden'
  }

  auto() {
    this.dom.style.overflow = 'auto'
  }
}

export function openDmp() {
  if (isWan()) {
    window.open('//cm.bilibili.com/skydmp/#/?biz_sys_from=3', '_blank')
  } else {
    window.open('//cm-mng.bilibili.co/skydmp/#/', '_blank')
  }
}

export const goHuahuoLogin = () => {
  location.href = location.origin + location.pathname + '#/login'
  location.reload()
}
